import Vue from 'vue'
import Router from 'vue-router'
import Project from '@/components/project/project' // 产品
import BannerContent from '@/components/project/bannerContent' // 产品
import DaiJia from '@/components/project/daijia/daijia' // 代驾
import DaiJiaAwait from '@/components/project/daijia/await' // 代驾 等待中
import DaiJiaService from '@/components/project/daijia/service' // 代驾 服务中
import DaiJiaSettlement from '@/components/project/daijia/settlement' // 代驾 结算
import DaiJiaAffirm from '@/components/project/daijia/affirm' // 代驾 评价
import DaiJiaCheckOrder from '@/components/project/daijia/checkOrder' // 代驾 订单查看
import Inform from '@/components/inform/inform' // 通知
import qrCode from '@/components/qrCode/qrCode' // 分享
import friend from '@/components/friend/friend' // 立即
import Settings from '@/components/settings/settings' // 设置
import serviceAgreement from '@/components/settings/serviceAgreement' // 服务协议
import servicePrice from '@/components/settings/servicePrice' // 服务价格
import CompileNom from '@/components/compileNom/compileNom' // 修改个人信息
import MeWallet from '@/components/mewallet/mewallet' // 钱包
import Invoice from '@/components/mewallet/invoice/invoice' // 发票
import invoiceApply from '@/components/mewallet/invoice/invoiceApply' // 发票申请
import InvoiceRecord from '@/components/mewallet/invoice/invoiceRecord' // 发票申请
import invoiceOrderRecord from '@/components/mewallet/invoice/invoiceOrderRecord' // 发票选择订单
import CapitalRecord from '@/components/mewallet/capitalRecord/capitalRecord' // 资金流水
import Recharge from '@/components/recharge/recharge' // 充值
import Coupon from '@/components/mewallet/coupon/coupon' // 优惠券
import CouponStale from '@/components/mewallet/coupon/stale' // 优惠券 已过期
import CouponUnused from '@/components/mewallet/coupon/unused' // 优惠券 未使用
import CouponUsed from '@/components/mewallet/coupon/used' // 优惠券 已使用
import OrderRecord from '@/components/orderRecord/orderRecord' // 订单记录
import login from '@/components/login/login' // 登录

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Project',
      component: Project,
      children: [
        {
          path: 'daijia',
          name: 'DaiJia',
          component: DaiJia
        }
      ]
    },
    {
      path: '/inform',
      name: 'Inform',
      component: Inform
    },
    {
      path: '/qrCode',
      name: 'qrCode',
      component: qrCode
    },
    {
      path: '/friend',
      name: 'friend',
      component: friend
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/serviceAgreement',
      name: 'serviceAgreement',
      component: serviceAgreement
    },
    {
      path: '/servicePrice',
      name: 'servicePrice',
      component: servicePrice
    },
    {
      path: '/mewallet',
      name: 'MeWallet',
      component: MeWallet
    },
    {
      path: '/invoice',
      name: 'Invoice',
      component: Invoice
    },
    {
      path: '/invoiceRecord',
      name: 'InvoiceRecord',
      component: InvoiceRecord
    },
    {
      path: '/invoiceApply',
      name: 'invoiceApply',
      component: invoiceApply
    },
    {
      path: '/invoiceOrderRecord',
      name: 'invoiceOrderRecord',
      component: invoiceOrderRecord
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: Coupon,
      children: [
        {
          path: 'stale',
          name: 'CouponStale',
          component: CouponStale
        },
        {
          path: 'used',
          name: 'CouponUsed',
          component: CouponUsed
        },
        {
          path: 'nused',
          name: 'CouponUnused',
          component: CouponUnused
        }
      ]
    },
    {
      path: '/compileNom',
      name: 'CompileNom',
      component: CompileNom
    },
    {
      path: '/capitalRecord',
      name: 'CapitalRecord',
      component: CapitalRecord
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: '/daijia/await',
      name: 'DaiJiaAwait',
      component: DaiJiaAwait
    },
    {
      path: '/daijia/service',
      name: 'DaiJiaService',
      component: DaiJiaService
    },
    {
      path: '/daijia/settlement',
      name: 'DaiJiaSettlement',
      component: DaiJiaSettlement
    },
    {
      path: '/daijia/affirm',
      name: 'DaiJiaAffirm',
      component: DaiJiaAffirm
    },
    {
      path: '/daijia/checkOrder',
      name: 'DaiJiaCheckOrder',
      component: DaiJiaCheckOrder
    },
    {
      path: '/orderRecord',
      name: 'OrderRecord',
      component: OrderRecord
    },
    {
      path: '/bannerContent',
      name: 'BannerContent',
      component: BannerContent
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {path: '*', redirect: '/'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js